import React from 'react';
import ItemControlButtons from '../ItemControlButtons';
import { useTranslation } from 'react-i18next';
import PortfolioIcon from '@wix/da-ds/pkg/Icons/Portfolio';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { GallectionType } from '../../../types/gallection';
export var FeaturedGallectionControlButtons = function (_a) {
    var gallection = _a.gallection, className = _a.className, openWixPortfolioModal = _a.openWixPortfolioModal, hasWixPortfolio = _a.hasWixPortfolio;
    var t = useTranslation().t;
    var isGallery = gallection.type === GallectionType.GALLERY;
    var itemsList = isGallery &&
        !hasWixPortfolio && [
        {
            items: [
                {
                    label: t('wixPortfolio.folderSync.menuCreate'),
                    icon: React.createElement(PortfolioIcon, { size: IconSize.SMALL }),
                    onClick: function () { return gallection && openWixPortfolioModal(gallection); },
                },
            ],
        },
    ];
    if (!itemsList) {
        return null;
    }
    return React.createElement(ItemControlButtons, { className: className, menuItems: itemsList });
};
FeaturedGallectionControlButtons.displayName =
    'FeaturedGallectionControlButtons';
export default FeaturedGallectionControlButtons;
//# sourceMappingURL=FeaturedGallectionControlButtons.js.map